var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveFeedbackNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17l-1.4-1.4 1.575-1.6H11.5v-2h4.175L14.1 10.4 15.5 9l4 4-4 4zm-15 0V2c0-.55.196-1.02.587-1.413A1.926 1.926 0 012.5 0h12c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412v5.075a3.416 3.416 0 00-.5-.063 10.015 10.015 0 00-1 0c-.167.009-.333.03-.5.063V2h-12v10h7.075a3.416 3.416 0 00-.063.5 10.015 10.015 0 000 1c.009.167.03.333.063.5H3.5l-3 3zm4-11h8V4h-8v2zm0 4h5V8h-5v2z"
  })));
}
export default SvgGiveFeedbackNew;